import type { CommandServices } from '@wix/cli-command-contract';
import { createI18nT } from '../i18n.js';
import { createLogger } from '../logger.js';
import type { ProjectModel } from '../model.js';
import { authenticate } from '../authentication.js';
import {
  resolvePackageManager,
  resolveNpmDependencies,
  migrateToAnyNpmIfNeeded,
} from '../velo-npm/index.js';

export async function install(
  model: ProjectModel,
  { biLogger, errorReporter }: CommandServices,
  options: {
    yarn?: boolean;
    npm?: boolean;
  },
  initialPackageName?: string
) {
  const authState = await authenticate({
    metaSiteId: model.metaSiteId,
    biLogger,
    errorReporter,
  });

  const t = createI18nT();
  const logger = createLogger({ t });
  const packageName = initialPackageName?.trim() ?? null;

  await migrateToAnyNpmIfNeeded(model.projectFolder, logger);

  const logInstalled = packageName
    ? logger.logDependencyInstalling(packageName)
    : logger.logAllDependenciesInstalling();

  try {
    const packageManager = await resolvePackageManager(
      model.projectFolder,
      options
    );

    if (packageName) {
      await packageManager.runInstallPackage(model.projectFolder, packageName);
    } else {
      await packageManager.runInstall(model.projectFolder);
    }

    await resolveNpmDependencies(model.projectFolder, { authState });

    logInstalled.success();
  } catch (error) {
    logInstalled.fail();
    throw error;
  }
}
